import React from 'react';
import { colourString } from '@keplerco/core';
import { CircleCheckTwoToneIcon } from '../../../../design/icons/circle-check-two-tone.icon';
import { CSSProperties } from 'styled-components';
import styles from './rater-radio-button.module.css';
import { IRaterRadioButtonProps } from './rater-radio-button.models';

export function RaterRadioButton(props: IRaterRadioButtonProps): JSX.Element {
  return (
    <li className={styles.listItem} style={{ '--colour': colourString(props.colour) } as CSSProperties}>
      <input className={styles.input} type="radio" id={props.details.id.toString()} name={props.details.label} value={props.point.rating} checked={props.details.rating !== undefined && props.details.rating === props.point.rating} onChange={props.onChange} />

      <div className={styles.radioButton}>
        <span className={styles.radioButtonBackground}>
          <CircleCheckTwoToneIcon primaryTone="transparent" />
        </span>
      </div>

      <label className={styles.label} htmlFor={props.details.id.toString()}>
        {(props.isSelf ? props.point.selfLabel : props.point.peerLabel) || props.point.label}
      </label>
    </li>
  );
}
